import Qs from 'querystring';

import { apiHost } from '../config';
import { SURVEY } from '../constants';

export const createBooking = (
  boatWeekId,
  girls,
  boys,
  skipper,
  hostess,
  currency,
  planId,
  extras
) => dispatch => {
  dispatch({
    type: 'SET_BOOKING_LOADING',
    loading: true
  });
  const qstr = Qs.stringify({
    girls,
    boys,
    skipper,
    hostess,
    currency,
    planId,
    extras
  });
  return fetch(`${apiHost}/api/booking/start/${boatWeekId}?${qstr}`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      dispatch({
        type: 'SET_BOOKING_ERROR',
        message: response.message
      });
      return response;
    })
    .catch(ex => console.log('failed fetching user', ex));
};

export const createProductBooking = (
  standardYachtWeekId,
  girls,
  boys,
  skipper,
  hostess,
  currency,
  planId,
  extras
) => dispatch => {
  dispatch({
    type: 'SET_BOOKING_LOADING',
    loading: true
  });

  const qstr = Qs.stringify({
    girls,
    boys,
    skipper,
    hostess,
    currency,
    planId,
    extras
  });
  return fetch(`${apiHost}/api/booking/start-2/${standardYachtWeekId}?${qstr}`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      dispatch({
        type: 'SET_BOOKING_ERROR',
        message: response.message
      });
      return response;
    })
    .catch(ex => console.log('failed fetching user', ex));
};

export const getActiveBooking = (bookingId = null, loading = true) => dispatch => {
  if (loading) {
    dispatch({
      type: 'SET_BOOKING_LOADING',
      loading: true
    });
  }
  return fetch(`${apiHost}/api/booking/${bookingId || ''}`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        const booking = response.data;
        // BC for older bookings:
        if (booking.destination === undefined) {
          if (booking.week !== undefined) {
            booking.destination = booking.week.destination;
          }
        }
        dispatch({
          type: 'UPDATE_BOOKING',
          booking
        });
        return response.data;
      }
      dispatch({
        type: 'UPDATE_BOOKING',
        booking: undefined
      });
      dispatch({
        type: 'SET_BOOKING_ERROR',
        message: response.message
      });
      return null;
    })
    .catch(ex => console.log('failed fetching user', ex));
};

export const cancelBooking = bookingId => dispatch =>
  fetch(`${apiHost}/api/booking/${bookingId}/cancel`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: undefined
        });
      }
    })
    .catch(ex => console.error('failed canceling booking', ex));

export const checkoutBooking = bookingId => dispatch =>
  fetch(`${apiHost}/api/booking/${bookingId}/checkout`, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
        return response.data;
      }
      return null;
    })
    .catch(ex => console.log('failed fetching user', ex));

export const deleteCrewMember = (member, bookingId) => dispatch => {
  const memberId = member.id;
  return fetch(`/api/booking/${bookingId}/delete-crew-member`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      crewMemberId: member.id
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'DELETE_MEMBER',
          memberId
        });
      }
      return response;
    });
};

export const addUserToCrew = booking => dispatch =>
  fetch(`/api/booking/${booking.id}/add-user-to-crew`, {
    method: 'POST',
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'ADD_USER',
          crewMember: response.data
        });
      }
      return response;
    });

export const sendCrewInvitation = (booking, emails) => dispatch => {
  const bookingId = booking.id;
  return fetch(`/api/booking/${bookingId}/send-invites`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      emails
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'INVITE_EMAILS',
          crewInvites: response.data.crewInvites
        });
      }
      return response;
    });
};

export const updatePayLinks = (booking, payLinks) => dispatch => {
  const bookingId = booking.id;
  return fetch(`/api/booking/${bookingId}/create-paylink`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      payLinks
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_PAYLINKS',
          payLinks: response.data
        });
      }
      return response;
    });
};

export const updatePayLink = (payLinkId, action) => dispatch => {
  if (action !== 'paid' && action !== 'cancelled') {
    return {
      status: 'failed',
      message: 'Action not recognised'
    };
  }
  return fetch(`/api/payment/paylink/${payLinkId}/${action}`, {
    method: 'POST',
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_PAYLINK',
          payLink: response.data
        });
      }
      return response;
    });
};

/** @deprecated Legacy cost-split action; never dispatched from UI. */
export const setCostSplit = (booking, costSplit) => dispatch => {
  fetch(`/api/booking/${booking.id}/cost-splitting`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      costSplit
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
      }
      return response;
    });
};

export const setCrewFinder = (booking, numBoys, numGirls, price, message, visible, languages) => dispatch =>
  fetch(`/api/booking/${booking.id}/crew-finder`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      numBoys,
      numGirls,
      price,
      message,
      visible,
      languages: languages.join(', ') // Storing as string in DB
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_CREW_FINDER',
          booking: response.data.booking,
          crewFinder: response.data.crewFinder
        });
        dispatch({
          type: 'SAVE_CREW_FINDER_DATA',
          crewFinderData: { data: response.data.crewFinderData }
        });

      }
      return response;
    });

export const nominateStaff = (type, bookingId, profileId, name) => dispatch => {
  fetch(`/api/staff/nominate/${type}/${bookingId}`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ profileId, name })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data
        });
      }
      return response;
    });
};

export const updateCrewName = (booking, crewName) => dispatch =>
  fetch(`/api/booking/${booking.id}/update-crew-name`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ crewName })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_CREW_DATA',
          crewData: {
            crewName: response.data?.crewName
          }
        });
      }
      if (response.status === 'failed') {
        throw new Error(response.message);
      }
      return response;
    })
    .catch(error => {
      console.error('failed updating crew name', error);
      return { status: 'failed', error: { message: error.message } };
    });
export const updateCrewRatio = (booking, boys, girls) => dispatch =>
  fetch(`/api/booking/${booking.id}/update-crew-ratio`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ boys, girls })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_CREW_DATA',
          crewData: {
            numBoys: response.data?.numBoys,
            numGirls: response.data?.numGirls,
            refactoredOrder: response.data?.refactoredOrder,
            mainOrder: response.data?.mainOrder
          }
        });
      }
      return response;
    }).catch(err => console.error({ err }));

export const patchCheckInInfo = (bookingId, payload) => dispatch =>
  fetch(`${apiHost}/api/account/booking/${bookingId}/check-in-info`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then(response => {
      if (response.status === 'success' && response.data && response.data.myCheckinData) {
        dispatch(getActiveBooking(bookingId, false));
      }
      return response;
    });

export const getSurvey = bookingId => dispatch =>
  fetch(`${apiHost}/api/survey/get-survey/${SURVEY.ID}/${bookingId}`, {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_SURVEY',
          survey: response.data
        });
      }
      return response;
    })
    .catch(ex => {
      console.log('failed getting survey', ex);
      return { status: 'failed', message: ex.message };
    });

export const submitSurvey = submission => dispatch =>
  fetch(`${apiHost}/api/survey/submit`, {
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify({ ...submission })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_SURVEY',
          survey: undefined
        });
      }
      return response;
    })
    .catch(ex => {
      console.log('failed submitting survey', ex);
      return { status: 'failed', message: ex.message };
    });

export const upgradeBooking = (bookingId, packageId) => dispatch =>
  fetch(`${apiHost}/api/booking/${bookingId}/upgrade`, {
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify({ packageId })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        const orderItems = Object.values(response.data.booking.mainOrder.orderItems);
        const normalizedBooking = {
          ...response.data.booking,
          mainOrder: {
            ...response.data.booking.mainOrder,
            orderItems
          }
        };
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: normalizedBooking
        });
        dispatch({
          type: 'SET_BOOKING_UPGRADE',
          bookingUpgrade: {
            price: 0,
            available: false,
            oldStandardYacht: null,
            newStandardYacht: null
          }
        });
      }
      return response;
    })
    .catch(ex => {
      console.log('failed upgrading cabins', ex);
      return { status: 'failed', message: ex.message };
    });

export const getBookingUpgradeData = bookingId => dispatch =>
  fetch(`${apiHost}/api/booking/${bookingId}/upgrade`, {
    credentials: 'same-origin',
    method: 'GET'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_BOOKING_UPGRADE',
          bookingUpgrade: response.data
        });
      }
      return response;
    });

export const submitPromoCode = (bookingId, code) => dispatch =>
  fetch(`${apiHost}/api/booking/${bookingId}/apply-code`, {
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify({ code })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: response.data.booking
        });
      }
      return response;
    });

export const fetchWeekAutomaticDiscounts = async () => {
  try {
    const res = await fetch('/api/yl/week-auto-promo-discounts', {
      credentials: 'same-origin'
    });
    return await res.json();
  } catch(e) {
    console.error(e);
  }
};

export const submitAppFeedback = (booking, data) => dispatch =>
  fetch(`${apiHost}/api/booking/${booking.id}/submit-feedback`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_BOOKING',
          booking: {
            ...booking,
            hasAppFeedback: true
          }
        });
      }
      return response;
    })
    .catch(e => console.error(e?.message));